export const projects = [
  {
    category: "/ PROJECTS",
    title: "Challenge/Frontend Aerolab",
    description:
      "Web application that allows users to search for and digitally collect video games, using the IGDB API.",
    image: "/images/Home.png",
    link: "https://frontend-challenge-aerolab.vercel.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Current Portfolio",
    description: "Design and development of my personal portfolio with React.",
    image: "/images/Home.png",
    link: "https://www.behance.net/gallery/215849223/Personal-Portfolio-2025?",
  },
  {
    category: "/ PROJECTS",
    title: "Cryptocurrency Shopping",
    description:
      "Project of Laboratorio subject, virtual wallet of cryptocurrencies.",
    image: "/images/Home.png",
    link: "https://github.com/candelaojeda/wallet-criptocoins",
  },
  {
    category: "/ PROJECTS",
    title: "Previous Portfolio",
    description: "Design and development of my previous personal portfolio.",
    image: "/images/portfolioanterior.png",
    link: "https://playful-chebakia-348ef6.netlify.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Pomodoro Timer",
    description: "Application to set what work time and rest time.",
    image: "/images/pomodoro.png",
    link: "https://github.com/candelaojeda/pomodoro/tree/master",
  },
  {
    category: "/ PROJECTS",
    title: "Shop Online",
    description:
      "Technical challenge that I did in the Onboarding 2021 of the Rooftop company.",
    image: "/images/shopOnline.png",
    link: "https://epic-babbage-7dbefe.netlify.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Healthy Shop",
    description: "Website for healthy store.",
    image: "/images/tienda-saludable.png",
    link: "https://vigilant-kowalevski-796973.netlify.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Weather App",
    description: "Application to know the state of the weather.",
    image: "/images/weather-app.png",
    link: "https://lucid-knuth-d4138c.netlify.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Desktop Calculator",
    description: "Calculator application made for a university subject.",
    image: "/images/calculadora.png",
    link: "https://optimistic-benz-9c7eb5.netlify.app/",
  },
  {
    category: "/ PROJECTS",
    title: "Desktop Estimate App",
    description: "Application to estimate income and expenses.",
    image: "/images/estimate-app.png",
    link: "https://vigorous-bardeen-66d79f.netlify.app/",
  },
];

export const logos = [
  {
    category: "/ LOGOS",
    title: "CANDELA OJEDA",
    description: "Personal Brand",
    image: "/logos/cande-brand-logo.svg",
  },
  {
    category: "/ LOGOS",
    title: "FLOW",
    description: "Children's events",
    image: "/logos/flow-salon.svg",
  },
  {
    category: "/ LOGOS",
    title: "CANDESIGN",
    description: "Content Creator",
    image: "/logos/candesign (1).svg",
  },
  {
    category: "/ LOGOS",
    title: "AURA NAILS",
    description: "Professional Manicurist",
    image: "/logos/aura (1).svg",
  },
  {
    category: "/ LOGOS",
    title: "SENTIRES",
    description: "Space Design",
    image: "/logos/sentires-logo.svg",
  },
];

export const socialMedia = [
  {
    category: "/ SOCIAL MEDIA",
    title: "Instagram Feed Flow",
    description: "Instagram feed design Flow.",
    image: "/images/flow-sm.png",
    link: "https://www.behance.net/gallery/200804151/Social-Media-Instagram-Feed",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Instagram Posts Aura Nails",
    description: "Instagram post design Aura Nails.",
    image: "/images/aura-post-sm.png",
    link: "https://www.instagram.com/aura.by.mili/",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Instagram Featured Stories",
    description: "Instagram feed design Aura Nails.",
    image: "/images/aura-stories-sm.png",
    link: "https://www.behance.net/gallery/211276867/Logo-Design-Presentation",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Instagram Feed Candesign",
    description: "Instagram Feed Candesign.",
    image: "/images/1ro.png",
    link: "https://www.behance.net/gallery/214189877/Social-Media-Instagram-Feed",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Invitation Card Design",
    description: "Birthday.",
    image: "/images/Negro50.png",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Invitation Card Design",
    description: "Children's Birthday.",
    image: "/images/Invitación ISABELA.png",
  },
  {
    category: "/ SOCIAL MEDIA",
    title: "Halloween Card Design",
    description: "Party invitation.",
    image: "/images/halloween card.png",
  },
];
